<template>
  <div class="sidebar">
  <el-container>
      <el-menu :default-active="activepath" class="el-menu-vertical-demo index" background-color="#304156" text-color="#fff" active-text-color="#ffd04b" router :collapse="sidebarWidth">
        <sidebarList :menu="menu"></sidebarList>
      </el-menu>
  </el-container>
  </div>
</template>

<script>
  import { permissionRouter } from '@/router'
  import {mapMutations, mapState} from 'vuex'
  import sidebarList from './sidebarList.vue'
  export default {
    data() {
      return{
        // sidebarWidth:false
      }
    },
    watch:{
      // sidebarWidth:{
      //   handler(e){
      //   }
      // }
    },
    props:{
      sidebarWidth:{
        type:Boolean
      }
    },
    components:{
      sidebarList
    },
    computed:{
      ...mapState(['menu']),
      activepath(){
       return this.$route.path
      },
      getRoutes() {
        return global.antRouter
      },
    },
    mounted() {},
    methods:{
      add(){
        this.$axios.get('/seller/shopMemberSeller/verifyMemberName?memberName=8888889').then(res=>{
          // console.log(res)
        })
      }
    }
  }
</script>

<style>
  .sidebar{
    height: 100vh;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 200px;
      /* min-width: 400px; */
    }
  * {
    margin: 0;
    padding: 0;
  }
  .index{
    /* text-align: center; */
  }
  .el-container {
    background-color: #FFFFFF;
    height: 100%;
  }

  .el-aside {
    background-color: #304156;
  }
  .el-main{
    background-color: #E9EEF3;
  }
</style>
